/** The Hanggent server mounts trigger routes under /api; /api/v1 is Eigent. */
export function executionSubscriptionUrl(baseURL: string): string {
  const origin = new URL(baseURL);
  origin.protocol = origin.protocol === 'https:' ? 'wss:' : 'ws:';
  origin.pathname = '/api/execution/subscribe';
  origin.search = '';
  origin.hash = '';
  return origin.toString();
}
